export default __webpack_public_path__ + "static/media/notion.56c5eec2.svg";